import React from 'react'
import { CheckBox, ErrorWrapper, Input, Label, Rules, RulesContainer, TabChanger } from '../../../styles/newStyles/Register.styled'
import Text from '../../../core/utils/Text'
import { AnimatePresence } from 'framer-motion'
import { GoCheck } from 'react-icons/go'
import { HOME } from '../../../core/constants/urls'
import { TABLET_SIZE } from '../../../core/constants/common'
import { useWindowSize } from '../../../core/hooks/useWindowSize'
import { useMainContext } from '../../../core/contexts/main'
import SetPasswordForm from '../components/SetPasswordForm'
import MailIcon from '../../../components/icons/MailIcon'
import UserGroupIcon from '../../../components/icons/UserGroupIcon'

const SignupPage = ({ onInputValueChange,
    onCheckBoxClicked,
    inputValues,
    goToRules,
    validationStatus,
}) => {
    const { main: { lang } } = useMainContext()
    const { width } = useWindowSize()

    return (
        <>
            <div className='flex flex-col gap-2'>
                <Label htmlFor='email'>
                    <MailIcon size={16} color='#869BDD' />
                    <Text tid={'email-address'} className='text-inherit' />
                </Label>
                <Input
                    name='username'
                    type='text'
                    placeholder={lang === 'fa' ? ' ایمیل خود را وارد کنید' : "Enter your email address"}
                    onChange={(e) => onInputValueChange(e, 'main')}
                    value={inputValues.mobileOrEmail}
                    autoFocus={true}
                    status={validationStatus}
                    id='email'
                />
                {validationStatus === 'error' && (
                    <ErrorWrapper>
                        <Text tid='wrong-format' className='text-sm' />
                    </ErrorWrapper>
                )}
            </div>
            <div className='flex flex-col gap-2'>
                <Label htmlFor='affiliate'>
                    <UserGroupIcon size={16} color='#869BDD' />
                    <Text tid={'invitation-code'} className='text-inherit' />
                </Label>
                <Input
                    name=''
                    type='text'
                    placeholder={lang === 'fa' ? 'کد دعوت خود را وارد کنید' : "Enter invitation code"}
                    onChange={(e) => onInputValueChange(e, 'option')}
                    value={inputValues.affiliateCode}
                    status={validationStatus}
                    id='affiliate'
                />
            </div>
            <AnimatePresence exitBeforeEnter>
                <>
                    <RulesContainer>
                        <CheckBox onClick={onCheckBoxClicked}>
                            {inputValues.rulesAccepted && (
                                <GoCheck size={16} color='#8481bd ' />
                            )}
                        </CheckBox>
                        {lang === 'en' ? (
                            <span className='text-sm text-[#E9EEFC]'>
                                I accept the <Rules> Terms & Conditions</Rules> and <Rules> Privacy Policy</Rules>
                            </span>
                        ) : (
                            <Label className='!font-kalameh !text-base'>
                                من تمام{' '}
                                <Rules onClick={goToRules}>
                                    <span className='text-mainColor underline underline-offset-4 font-semibold'>
                                        قوانین و مقررات
                                    </span>
                                </Rules>{' '}
                                سایت کندلایو را میپذیرم.
                            </Label>
                        )}
                    </RulesContainer>
                </>
            </AnimatePresence>
        </>
    )
}

export default SignupPage